//目录管理
import httpUtil from './base/httpUtil'
export default {
    //发送验证码
    getList(that,params,callback,error){
        httpUtil.httpGet(that,'/adminapi/product/get_list', params,function (res) {
          callback(res)
        },function (err) {
            console.log('err get' + err)
            if(error){
                error(err)
            }
        })
    },
    del(that,params,callback,error){

        httpUtil.httpDelete(that,'/adminapi/product/del', params,function (res) {
            callback(res)
        },function (err) {
            console.log('err get' + err)
            if(error){
                error(err)
            }
        })
    },
    getListByIndex(that,params,callback,error){
        httpUtil.httpGet(that,'/api/product/get_list_by_index', params,function (res) {
            callback(res)
        },function (err) {
            console.log('err get' + err)
            if(error){
                error(err)
            }
        })
    },

    getListByProduct(that,params,callback,error){
        httpUtil.httpGet(that,'/api/product/get_list_by_product', params,function (res) {
            callback(res)
        },function (err) {
            console.log('err get' + err)
            if(error){
                error(err)
            }
        })
    },




}



// WEBPACK FOOTER //
// ./src/service/ProductService.js